











import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class SimpleTd extends Vue {
  @Prop() title!: string

  @Prop() value!: string

  @Prop({
    default: false
  }) grow!: boolean

  get dataClasses() {
    return this.grow ? 'col-grow' : 'col-shrink'
  }
}
